module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/sightseeing_3-84d419eaac65c2cc2155a26a8cf7a61c.jpg";